export type SearchMode = 'title' | 'user';

export type SuggestionPost = { _id: string; title?: string };

export function feedSearchPath(query: string, mode: SearchMode): string {
  const params = new URLSearchParams({ searchQuery: query, searchMode: mode });
  return `/?${params.toString()}`;
}

// Which suggestion an Enter press commits to, or null to fall through to the
// feed. An exact type-out wins; failing that, a lone result is unambiguous.
export function pickCommitLabel(
  query: string,
  suggestions: string[]
): string | null {
  const trimmed = query.trim().toLowerCase();
  const exact = suggestions.find((s) => s.toLowerCase() === trimmed);
  if (exact) return exact;
  return suggestions.length === 1 ? suggestions[0] : null;
}

// Only post titles carry an id in the autocomplete payload; project-group
// names fall through to the feed, which surfaces the group.
export function resolveSearchTarget(
  label: string,
  mode: SearchMode,
  posts: SuggestionPost[],
  isAuthenticated: boolean
): string {
  if (mode === 'user') {
    // /:username is behind PrivateRoute; anonymous clicks would bounce to login.
    return isAuthenticated ? `/${label}` : feedSearchPath(label, mode);
  }
  const post = posts.find((p) => p.title === label);
  return post ? `/model/${post._id}` : feedSearchPath(label, mode);
}
